// extracted by mini-css-extract-plugin
module.exports = {"input":"integer_input_input__1MsHN","toggleIcon":"integer_input_toggleIcon__UoX6u","label":"integer_input_label__1ZjPX","container":"integer_input_container__2jiN9"};